import React from "react";
import { Box, useMediaQuery } from "@mui/material";
import { MapPin } from "lucide-react";

const LocationSlider = () => {
  const isMobile = useMediaQuery('(max-width:600px)');
  const imageBaseUrl = process.env.REACT_APP_IMAGE_BASE_URL;
  const locations = [
    {
      id: "UC241",
      name: "UClean Kathmandu ",
      address:
        "Ward No 16, Opposite Of Hotel Timberhouse, Paknajol, Chhetrapati, Kathmandu Municipality, Nepal - 44600",
    },
    {
      id: "UC301",
      name: "UClean Kathmandu",
      address:
        "Nawa Prabhat Marga, Kathmandu, Nepal - 44600",
    },
    {
      id: "UC352",
      name: "UClean Pokhara",
      address:
        "Lakeside Rd, Pokhara, Nepal - 33700",
    },
   
  ];

  return (
    <Box sx={styles.wrapper}>
      <Box sx={styles.container}>
        {/* Map shown first on mobile */}
        {isMobile && (
          <Box sx={styles.mapContainer}>
            <Box sx={[styles.mapContent,{backgroundImage: `url(${imageBaseUrl}nepalimg.png)`,}]} />
          </Box>
        )}

        {/* Location cards */}
        <Box sx={styles.leftContainer}>
          <Box sx={styles.cardContainer}>
            {locations.map((location, index) => (
              <Box key={index} sx={styles.card}>
                <Box sx={styles.cardContent}>
                  <Box sx={styles.iconContainer}>
                    <MapPin style={styles.icon} />
                  </Box>
                  <Box sx={styles.locationInfo}>
                    <Box component="h3" sx={styles.locationTitle}>
                      {location.id} - {location.name}
                    </Box>
                    <Box component="p" sx={styles.locationAddress}>
                      {location.address}
                    </Box>
                    {/* <Box component="button" sx={styles.viewDetailsButton}>
                      View Details
                    </Box> */}
                  </Box>
                </Box>
              </Box>
            ))}
          </Box>
        </Box>

        {/* Map for tablet and desktop */}
        {!isMobile && (
          <Box sx={styles.mapContainer}>
            <Box sx={[styles.mapContent,{backgroundImage: `url(${imageBaseUrl}nepalimg.png)`,}]} />
          </Box>
        )}
      </Box>
    </Box>
  );
};

const styles = {
  wrapper: {
    display: "flex",
    justifyContent: "center",
    width: "100%",
  },
  container: {
    display: "flex",
    flexDirection: {
      xs: "column",
      md: "row"
    },
    gap: {
      xs: "16px",
      sm: "20px"
    },
    width:{xs:'90%',md:'62%'},
    position: "relative",
  },
  leftContainer: {
    width: {
      xs: "100%",
      md: "33%"
    },
    position: "relative",
    direction: "rtl",
  },
  cardContainer: {
    maxHeight: {
      xs: "400px",
      sm: "500px",
      md: "600px"
    },
    overflowY: "auto",
    paddingRight: {
      xs: "4px",
      sm: "8px"
    },
    paddingLeft: {
      xs: "8px",
      sm: "16px"
    },
    display: "flex",
    flexDirection: "column",
    gap: {
      xs: "12px",
      sm: "16px"
    },
    direction: "ltr",
    "&::-webkit-scrollbar": {
      width: "4px",
      backgroundColor: "#E5E7EB",
    },
    "&::-webkit-scrollbar-thumb": {
      backgroundColor: "#9CA3AF",
      borderRadius: "2px",
      "&:hover": {
        backgroundColor: "#6B7280",
      },
    },
    scrollbarWidth: "thin",
    scrollbarColor: "#9CA3AF #E5E7EB",
  },
  card: {
    backgroundColor: "#fff",
    borderRadius: {
      xs: "6px",
      sm: "8px"
    },
    boxShadow: "0 2px 4px rgba(0, 0, 0, 0.1)",
    transition: "box-shadow 0.3s ease",
    cursor: "pointer",
    "&:hover": {
      boxShadow: "0 4px 8px rgba(0, 0, 0, 0.15)",
    },
  },
  cardContent: {
    padding: {
      xs: "12px",
      sm: "16px"
    },
    display: "flex",
    alignItems: "flex-start",
    gap: {
      xs: "8px",
      sm: "12px"
    },
  },
  iconContainer: {
    flexShrink: 0,
  },
  icon: {
    width: {
      xs: "16px",
      sm: "20px"
    },
    height: {
      xs: "16px",
      sm: "20px"
    },
    color: "#16a34a",
  },
  locationInfo: {
    flex: 1,
  },
  locationTitle: {
    color: "#166534",
    fontSize: {
      xs: "14px",
      sm: "16px"
    },
    fontFamily: ' "Poppins", serif ',
    fontWeight: 600,
    marginBottom: "4px",
    margin: 0,
  },
  locationAddress: {
    color: "#4B5563",
    fontSize: {
      xs: "12px",
      sm: "14px"
    },
    marginBottom: "8px",
    lineHeight: 1.5,
    margin: 0,
    fontFamily: ' "Poppins", serif ',
    fontWeight: 400,
  },
  viewDetailsButton: {
    color: "#16a34a",
    fontSize: {
      xs: "12px",
      sm: "14px"
    },
    background: "none",
    border: "none",
    padding: 0,
    cursor: "pointer",
    "&:hover": {
      color: "#15803d",
    },
  },
  mapContainer: {
    width: {
      xs: "100%",
      md: "67%"
    },
    backgroundColor: "#F3F4F6",
    borderRadius: {
      xs: "6px",
      sm: "8px"
    },
    overflow: "hidden",
  },
  mapContent: {
    width: "100%",
    height: {
      xs: "300px",
      sm: "400px",
      md: "500px"
    },
    
    backgroundSize: "cover",
    backgroundPosition: "center",
    backgroundRepeat: "no-repeat",
  },
};

export default LocationSlider;
